import secureLocalStorage from "react-secure-storage";
import { Popup } from "@progress/kendo-react-popup";
import React from "react";
import { PureComponent } from "react";
import { TextArea } from "@progress/kendo-react-inputs";
import Api from "../../../Services/Api";
import * as moment from "moment";
import { CircularProgress } from "@material-ui/core";

export default class ActionProgressPopup extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      temp: undefined, //this.props.dataItem[this.props.field],
      historyList:[],
      flag:true,
      loader: false,
      disable_inputfield:false,
    };

  }
 
  handleChange = (e) => {
    this.setState({ temp: e.value });
  };
  onSubmit = (e) => {
    this.props.onChange({
      dataItem: this.props.dataItem,
      field: this.props.field,
      syntheticEvent: e.syntheticEvent,
      value: this.state.temp,
    });
    this.closePopup();
  };

  actionProgressComments = async () => {
    try {
        this.setState({loader: true})
      let req = {
        riskRegisterActionId: this.props.dataItem.riskRegisterActionId,
      };
      let response = await Api.actionProgressComments(req);
      if (response.status === 200) {
        this.setState({...this.state,historyList:response.actionImpactComments,flag:false,loader: false});
      } else {
        this.setState({...this.state,historyList:[],flag:false,loader: false});
      }
    } catch (err) {
      console.log(err);
    }
  };

  handleEditCell = () => {
    if(this.props.dataItem.riskRegisterActionId){
       this.props.onEditCell(this.props.dataItem, this.props.field);
    }   
  };
  closePopup = () => {
    this.props.exitEdit();
  };
  handleOnBlur = (e) => {
    return;
  };
  
  render() {
    const { dataItem, field } = this.props;
    const loginUserId = parseInt(secureLocalStorage.getItem("loginUserId"));
    const ownerId = dataItem.userId;
    const riskOwnerId=this.props.riskDetails?this.props.riskDetails.userId:null;
    const isClosed = dataItem.isOpen === "Closed";
    const value = this.props.dataItem[this.props.field];
    if (
      (this.props.field && this.props.field === this.props.dataItem.inEdit) ||
      this.props.dataItem.inEdit === true
    ) {
        if(this.state.flag){
            this.actionProgressComments();
        }
      return (
        <td>
          <Popup
            show={this.props.field === this.props.dataItem.inEdit}
            popupClass={"popup-content"}
          >
              {this.state.loader ? (
                            <span className="MatTableSpinner">
                                <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
                            </span>
                        ) : null}
            <div className="deleteModelCont stackHolderSelection">
              <label className="fieldLabel">Add comments</label>
              <br></br>
              <div className="row cmttextarea">
                <div className="col-sm-3 col-md-7">
                  <TextArea
                    onChange={this.handleChange}
                    onBlur={this.handleOnBlur}
                    disabled={isClosed}
                  />
                </div>
                <div className="col-sm-3 col-md-3">
                  <div className="progressBtn">
                    <button
                      className="greenbtn"
                      type="button"
                      onClick={this.onSubmit}
                      disabled={!this.state.temp||isClosed}
                    >
                      Submit
                    </button>
                    &nbsp;&nbsp;
                    <button
                      onClick={this.closePopup}
                      className="redbtn"
                      type="button"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
              <br></br>
              <label className="fieldLabel">Progress History</label>
              <div className="commentsHistory">
                <ul className="comments">
                  {this.state.historyList&&this.state.historyList.map((item) => (
                    <li>
                      <p>{item.actionComment}</p>
                      <small>Date:{moment(new Date(item.createdDate)).format("DD-MMM-yyyy HH:mm:ss")}</small>{" "}
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
                      <small>Entered by:{item.userName}</small>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </Popup>
        </td>
      );
    }
    if (this.props.dataItem.inEdit !== this.props.field) {
      if ((loginUserId === ownerId || loginUserId===riskOwnerId) && this.props.dataItem.isOpen === true) {
        return (
          <td
            onClick={this.handleEditCell}
            style={{ left: "437px", right: "0px" }}
            title={value}
          >
            <span>{value}</span>
          </td>
        );
      } else {
        return this.props.dataItem.role == "Standard User" ||
          this.props.dataItem.role == "View Only" || this.props.dataItem.isOpen == false ? (
          <td style={{ left: "290px", right: "0px" }} title={value}>
            <span>{value}</span>
          </td>
        ) : (
          <td
            onClick={this.handleEditCell}
            style={{ left: "437px", right: "0px" }}
            title={value}
          >
            <span>{value}</span>
          </td>
        );
      }
    }
  }
}